import { CloseButton, MantineSize, NumberInput } from "@mantine/core"
import { CurrencyCircleDollarIcon } from "@phosphor-icons/react";

type Props = {
  value: number | string | null | undefined
  onChange: (v: number | string) => void
  error?: React.ReactNode
  label?: string
  disabled?: boolean
  placeholder?: string
  noError?: boolean
  hideControls?: boolean
  classNames?: Partial<Record<string, string>> | undefined
  size?: MantineSize
  min?: number
  max?: number
  iconWidth?: any
  maxLength?: number
  required?: boolean
  precision?: number
  allowArrow?: boolean
  w?: string | any
}

export function NumberCurrencyField({
  value,
  onChange,
  error,
  label,
  noError = false,
  hideControls = false,
  placeholder,
  disabled = false,
  classNames,
  size = "sm",
  min,
  max,
  iconWidth,
  maxLength,
  required,
  allowArrow,
  w,
}: Props) {
  return (
    <NumberInput
      maxLength={maxLength}
      leftSectionWidth={iconWidth}
      w={w}
      max={max}
      min={min}
      size={size}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      value={value ?? ""}
      hideControls={hideControls}
      onChange={onChange}
      classNames={classNames}
      styles={{
        error: { display: noError ? "none" : "block" },
        wrapper: { marginBottom: error && noError ? 0 : undefined },
      }}
      required={required}
      rightSection={
        !allowArrow && (
          <CloseButton
            onClick={() => onChange("")}
            variant="transparent"
            size="sm"
            color="gray.6"
          />
        )
      }
      leftSection={<CurrencyCircleDollarIcon size={18} stroke="1.5" color="gray" opacity={0.8} />}
    />
  )
}
